<template>
  <div>
    <h1>
      Open Burn Application Search
    </h1>

    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-md-6">
        <base-input v-model="applicationNumber"
                    label="Application Number"
                    :message="errorMessage"
                    v-focus
                    v-on:keyup.enter="searchAppNumber">
        </base-input>
        <button class="btn btn-primary" @click="searchAppNumber">Search</button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput';
import { getOpenBurnApplication, validatePermitNumber } from '@/js/FormFunctions';

import { CapitalizeFilter } from '@/js/Mixins';

export default {
  name: 'OpenBurnApplicationSearch',
  components: { BaseInput },
  mixins: [CapitalizeFilter],
  data() {
    return {
      applicationNumber: null,
      fetchingData: false,
      isValidNum: false,
      error: null,
    };
  },
  directives: {
    focus: {
      inserted(el) {
        const inputEl = el.querySelector('input');
        inputEl.focus(inputEl);
      },
    },
  },
  methods: {
    searchAppNumber() {
      const self = this;
      this.fetchingData = true;
      this.isValid();
      if (this.isValidNum) {
        getOpenBurnApplication(this.applicationNumber)
          .then((data) => {
            self.$store.commit('temporaryForm', data);
            self.$router.push({
              name: 'OpenBurnApplication',
              params: { form: data },
            });
          })
          .catch((error) => {
            this.error = error;
            self.fetchingData = false;
          });
      } else {
        this.fetchingData = false;
      }
    },
    isValid() {
      validatePermitNumber(this.applicationNumber)
        .then((data) => {
          this.isValidNum = true;
        })
        .catch((error) => {
          this.error = error;
          this.fetchingData = false;
          this.isValidNum = false;
        });
    },
  },
  computed: {
    errorMessage() {
      if (this.error) {
        return `Error finding application: ${this.error.message}`;
      }
      return '';
    },
  },
};
</script>
